import { defineComponent as _defineComponent } from 'vue'
import { reactive } from "vue";
import { HttpError } from "ag-client-typescript";
import { SYSADMIN_CONTACT } from "@/constants";

// Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'api_errors',
  setup(__props, { expose, emit }: { emit: ({
  num_errors_changed: [count: number];
}), expose: any, slots: any, attrs: any }) {



// Reactive state object
const state = reactive({
  api_errors: [] as string[],
});

// Methods
const show_errors_from_response = (
  error_response: unknown,
  clear_current_errors = true,
) => {
  if (clear_current_errors) {
    state.api_errors = [];
  }

  // There isn't a great way to detect network errors, but we know
  // that the message will be "Network Error".
  // https://github.com/axios/axios/issues/383
  if ((<Error>error_response).message.includes("Network")) {
    state.api_errors.push(
      "Network error detected. Please check your connection and try again",
    );
    console.error(error_response);
  } else if (!(error_response instanceof HttpError)) {
    state.api_errors.push(
      "An unexpected error occurred. If the problem persists, please contact " +
        SYSADMIN_CONTACT +
        " and include the version number of your browser and " +
        "output of the JavaScript console " +
        "(https://webmasters.stackexchange.com/questions/8525/" +
        "how-do-i-open-the-javascript-console-in-different-browsers).",
    );
    console.error(error_response);
  } else if (error_response.status === 413) {
    state.api_errors.push(
      "Error: Request too large. If you are uploading files, please reduce their size.",
    );
  } else if (error_response.status === 400) {
    show_400_error_data(error_response);
  } else if (error_response.status === 401) {
    state.api_errors.push(
      "You are not signed in. Please sign in and try again.",
    );
  } else {
    let error_detail = JSON.stringify(error_response.data);
    if (error_response.status === 504) {
      error_detail = "The request timed out. Please try again later.";
    } else if (error_response.status === 502) {
      error_detail = "Bad gateway";
    }

    state.api_errors.push(
      `Error occurred requesting "${error_response.url}": ` +
        `${error_response.status} ${error_detail}`,
    );
  }

  emit("num_errors_changed", state.api_errors.length);
};

const show_400_error_data = (error: HttpError) => {
  if (typeof error.data === "string") {
    state.api_errors.push(error.data);
  } else {
    for (let [field_name, message] of Object.entries(error.data)) {
      if (field_name === "__all__") {
        if (Array.isArray(message)) {
          state.api_errors.push(String(message[0]));
        } else if (typeof message === "string") {
          state.api_errors.push(message);
        }
      } else {
        state.api_errors.push(`Error in "${field_name}": ${message}`);
      }
    }
  }
};

const clear = () => {
  state.api_errors = [];
  emit("num_errors_changed", 0);
};

// Expose state and methods for external access (tests, parent components)
expose({
  state,
  show_errors_from_response,
  clear,
});

return { __sfc: true,emit, state, show_errors_from_response, show_400_error_data, clear }
}

})